import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectHolder } from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import { ComplexityStatus } from '../../data/project/statuses/complexity-status';
import { ProjectStatus } from '../../data/project/statuses/project-status';
import {ProjectActivityService} from '../../data/project/activity/project-activity.service';

@Component({
  selector: 'app-complexity-edit',
  templateUrl: './complexity-edit.component.html',
  styleUrls: ['./complexity-edit.component.scss']
})
export class ComplexityEditComponent implements OnInit {
  project: Project;

  @Input()
  jobComplexity: ProjectStatus;

  @Input()
  manualComplexity: boolean;

  @Input()
  complexityHrs: number;

  tempComplexity: ProjectStatus;

  statuses: ProjectStatus[];

  constructor(
    private projectActivityService: ProjectActivityService,
    protected projectHolder: ProjectHolder,
    private projectService: ProjectService,
    private el: ElementRef
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.projectService.getComplexities().subscribe(statuses => {
      this.statuses = statuses;

      if(this.complexityHrs > 0) {
        const hrsText = ` (${this.complexityHrs.toFixed(2)}h)`
        let fStatus
        if(this.project.autoSelectedJobComplexity) {
          fStatus = this.statuses.find(status => status.id === this.project.autoSelectedJobComplexity.id)
        } else {
          fStatus = this.statuses.find(status => status.id === this.jobComplexity.id)
        }
        fStatus.title += hrsText

        if(this.jobComplexity.id === fStatus.id) {
          this.jobComplexity.title += hrsText
        }
      }

      if(this.jobComplexity) {
        this.tempComplexity = this.jobComplexity
      }
    });
  }

  complexityChange(event) {
    this.projectService
    .saveProject({
      id: this.project.id,
      jobComplexity: this.jobComplexity
    })
    .subscribe(() => {
      this.tempComplexity = this.jobComplexity
      this.updateActivities()
    }, error => {
      this.jobComplexity = this.tempComplexity;
    })
  }

  updateActivities() {
    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
    })
  }

}

